import { Component, inject } from '@angular/core';
import { CurrencyService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CurrencyCreateDto,
  CurrencyDto,
  CurrencyExcelDownloadDto,
  CurrencyUpdateDto,
} from '../proxy/controlling/dtos/currency';
import { CURRENCY_CONFIG, CURRENCY_FIELDS } from './currency.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-currency',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CurrencyService, ConfirmationService],
  templateUrl: './currency.html',
  styleUrl: './currency.scss',
})
export class Currency extends BaseCrudComponent<
  CurrencyDto,
  CurrencyCreateDto,
  CurrencyUpdateDto,
  CurrencyExcelDownloadDto
> {
  service = inject(CurrencyService);
  config = CURRENCY_CONFIG;
  fields = CURRENCY_FIELDS;

  protected prepareUpdateDto(data: any, selected: CurrencyDto): CurrencyUpdateDto {
    return {
      name: data.name,
      code: data.code,
      sapCode: data.sapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Currency';
  }
}
